import script from "./UOrganizationItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UOrganizationItem.vue?vue&type=script&setup=true&lang=ts"

import "./UOrganizationItem.vue?vue&type=style&index=0&id=2a9d1807&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9d1807"]])

export default __exports__